module.exports = __webpack_public_path__ + "static/media/mobile834.5a31e344.png";